import { CommonAdmin } from '../../../../i18n'
import CLanguageHandler from '../../../NonReact/Languages/LanguageHandler'
import { IsStringEmpty } from '../../../NonReact/utils/GlobalFunctions'
import { ALL_VALUE } from '../API/ItemsGetters'
import { SelectItem, SelectOption } from '../Components/Selects/Types'
import { SERVER_ALL_VALUE } from '../Constants/ServerValues'

/**
 * Constructs the default permissions for the permissions tab.
 */
export class FilterDefaults {
    public static INSTANCE: FilterDefaults

    private language: CLanguageHandler

    constructor(language: CLanguageHandler) {
        this.language = language

        this.language.loadBundle(CommonAdmin.NAME)
    }

    public getAllTelServersOption(): SelectOption<number> {
        return {
            label: this.language.get(CommonAdmin.CommonAdminAllTelServer),
            value: ALL_VALUE
        }
    }

    public getAnyPartitionOption(): SelectOption<number> {
        return {
            label: this.language.get(CommonAdmin.CommonAdminAnyPartition),
            value: ALL_VALUE
        }
    }

    public getAnyDevice(agent?: string): SelectItem {
        if (!IsStringEmpty(agent) && agent !== SERVER_ALL_VALUE) {
            return {
                label: this.language.get(CommonAdmin.CommonAdminAnyDeviceForAgent),
                value: SERVER_ALL_VALUE
            }
        }

        return {
            label: this.language.get(CommonAdmin.CommonAdminAnyDevices),
            value: SERVER_ALL_VALUE
        }
    }

    public getAnyAgent(device?: string): SelectItem {
        if (!IsStringEmpty(device) && device !== SERVER_ALL_VALUE) {
            return {
                label: this.language.get(CommonAdmin.CommonAdminAnyAgentForDevice),
                value: SERVER_ALL_VALUE
            }
        }

        return {
            label: this.language.get(CommonAdmin.CommonAdminAnyAgents),
            value: SERVER_ALL_VALUE
        }
    }

    public static getInstance(language: CLanguageHandler): FilterDefaults {
        if (!this.INSTANCE) {
            this.INSTANCE = new FilterDefaults(language)
        }

        return this.INSTANCE
    }
}
